import React, { useState, useEffect } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
    Button,
    ListItemIcon,
    Menu,
    MenuItem,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import i18next from 'i18next';
import isNil from 'lodash/isNil';
import PropTypes from 'prop-types';

const DropDownMenu = ({
    defaultLabel = i18next.t('All text', { context: 'male', count: 2 }),
    defaultValue,
    disabled = false,
    fullWidth,
    handleSelected,
    itemsToSelect = [],
    itemsToSelectValidationEnabled,
    keyName = '',
    startIconButton = null,
    sxButton,
    visible = true,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selected, setSelected] = useState({});

    useEffect(() => {
        if (defaultValue !== '' && itemsToSelect.length) {
            const itemSelected = itemsToSelect.filter(
                (item) => item.value == defaultValue,
            );

            if (itemSelected.length) {
                setSelected(itemSelected[0]);
            }
        }
    }, [defaultValue]);

    useEffect(() => {
        if (
            itemsToSelectValidationEnabled &&
            !isNil(selected.value) &&
            itemsToSelect
        ) {
            const values = itemsToSelect.map((item) => item.value);
            const selectedIndex = values.indexOf(selected.value);
            if (selectedIndex < 0) {
                if (defaultValue !== '' && values.length) {
                    const defaultValueIndex = values.indexOf(defaultValue);
                    if (defaultValueIndex >= 0) {
                        setSelected(itemsToSelect[defaultValueIndex]);
                    } else {
                        setSelected({});
                    }
                } else {
                    setSelected({});
                }
            }
        }
    }, [itemsToSelectValidationEnabled, selected, itemsToSelect, defaultValue]);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleMenuItemClick = (index, item) => {
        setSelectedIndex(index);
        setAnchorEl(null);
        if (item.value !== selected.value) {
            setSelected(item);
            handleSelected(item);
        }
    };
    const label = selected && selected.label ? selected.label : defaultLabel;
    const open = Boolean(anchorEl);

    if (!visible) return null;
    return (
        <>
            <Button
                disabled={disabled || itemsToSelect.length === 0}
                endIcon={<KeyboardArrowDownIcon />}
                fullWidth={fullWidth}
                onClick={handleClick}
                startIcon={startIconButton}
                sx={sxButton}
                variant="outlined"
            >
                <Typography
                    component="span"
                    fontWeight="bold"
                    noWrap
                    sx={{
                        overflow: 'hidden',
                        width: 'calc(100% - 16px)',
                        textAlign: 'left',
                        textOverflow: 'ellipsis',
                    }}
                    variant="body2"
                >
                    {label}
                </Typography>
            </Button>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {itemsToSelect?.map((item, index) => {
                    const {
                        disabled,
                        label,
                        visible = true,
                        icon,
                        iconPosition,
                    } = item;
                    return visible ? (
                        <MenuItem
                            disabled={disabled}
                            key={`${keyName}-dropdown-item-${index}`}
                            selected={index === selectedIndex}
                            onClick={() => handleMenuItemClick(index, item)}
                        >
                            {icon && iconPosition === 'left' && (
                                <ListItemIcon
                                    sx={{
                                        minWidth: '24px !important',
                                        mr: 1,
                                    }}
                                >
                                    {icon}
                                </ListItemIcon>
                            )}
                            <Typography variant="body2" color="#848bab">
                                {label}
                            </Typography>
                            {icon && iconPosition === 'right' && (
                                <ListItemIcon
                                    sx={{
                                        minWidth: '24px !important',
                                        ml: 'auto',
                                    }}
                                >
                                    {icon}
                                </ListItemIcon>
                            )}
                        </MenuItem>
                    ) : null;
                })}
            </Menu>
        </>
    );
};

DropDownMenu.propTypes = {
    defaultLabel: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    handleSelected: PropTypes.func,
    itemsToSelect: PropTypes.array,
    itemsToSelectValidationEnabled: PropTypes.bool,
    keyName: PropTypes.string,
    startIconButton: PropTypes.object,
    sxButton: PropTypes.object,
    visible: PropTypes.bool,
};

export default DropDownMenu;
